import { useState } from 'react';
import { Link } from 'react-router-dom';
import { PublicMobileMenu } from '@/components/PublicMobileMenu';

const P = [
  { n: 'د. يزيد البدارين', r: 'المشرف الرئيس', t: 'طالب دكتوراه في علوم الحاسب — جامعة شرق فنلندا', c: '#dd5f7a', img: '/founder_yazid.jpg', b: 'مكرّس لنشر تعليم الذكاء الاصطناعي وتسخيره لخدمة التعليم والصحة وريادة الأعمال وغيرها. يسعى د. البدارين لسدّ الفجوة بين التكنولوجيا المعقدة والتجربة الإنسانية من خلال الابتكار والبحث العلمي والإرشاد.', g: ['ذكاء اصطناعي', 'تعليم', 'بحث علمي', 'ريادة أعمال'] },
  { n: 'ليث عفانة', r: 'شريك مؤسس', t: 'فريق رشيد جي بي تي', c: '#6b4fd8', img: '/founder_laith.jpg', b: 'أؤمن بأن تطوير العلم هو الأساس الحقيقي لأي نهضة مستدامة، وأن الاستثمار في عقول الأجيال القادمة هو الطريق الأذكى لصناعة المستقبل. أهتم ببناء قدرات التفكير التحليلي وتعزيز الإبداع، انطلاقاً من قناعة بأن التعليم لا يجب أن يقتصر على نقل المعرفة، بل على تمكين الأفراد من فهمها وتطويرها وتوظيفها بفعالية. أسعى للمساهمة في إعداد جيل قادر على الابتكار واتخاذ القرار، بما يحقق أثراً حقيقياً في المجتمع، ويقود فلسطين بثقة نحو موقع متقدم بين الأمم.' },
  { n: 'شهد عبده', r: 'شريك مؤسس', t: 'فريق رشيد جي بي تي', c: '#e8834a', img: '/founder_shahd.jpg', b: 'أؤمن بأن التكنولوجيا يمكن أن تكون أداة حقيقية لصناعة التغيير وحل المشكلات التي تواجه الناس في حياتهم اليومية. وبصفتي متخصصة في علم الحاسب، أهتم بتطوير التعليم وتوظيف التقنية لابتكار حلول عملية تسهم في تحسين حياة الأفراد والمجتمع. أسعى إلى تحويل الأفكار إلى مشاريع وحلول ذات أثر، انطلاقاً من قناعة بأن المعرفة والتكنولوجيا عندما تجتمعان مع فهم احتياجات الناس، يمكن أن تصنعا فرقاً حقيقياً ومستداماً في هذه الحياة.' },
  { n: 'آية الخطيب', r: 'شريك مؤسس', t: 'فريق رشيد جي بي تي', c: '#2e7d4f', img: '/founder_aya.jpg', b: 'أؤمن بأن الأثر الحقيقي يبدأ من فكرة تحمل قيمة، ومن أشخاص يمتلكون الرغبة في تحويلها إلى واقع. أهتم بالمساهمة في بناء مبادرات ومشاريع تستجيب لاحتياجات المجتمع، وتخلق حلولاً ملموسة للتحديات التي يواجهها الأفراد. أسعى إلى العمل بروح الابتكار والتعاون، وتحويل الفرص إلى إنجازات تترك أثراً إيجابياً ومستداماً، إيماناً بأن صناعة المستقبل تبدأ بخطوات صغيرة، لكنها هادفة ومدروسة.' },
];

const S = [[11, 30], [89, 30], [50, 93]]; // satellite positions

const FounderPage = () => {
  // ord[0] is the centered member; the rest are satellites
  const [ord, setOrd] = useState([0, 1, 2, 3]);
  const active = P[ord[0]];

  const pick = (k) => {
    const j = ord.indexOf(k);
    if (j === 0) return;
    const nx = [...ord];
    nx[0] = k; nx[j] = ord[0];
    setOrd(nx);
  };

  return (
    <div className="fdpage" dir="rtl" style={{ '--c': active.c }}>
      {/* Header matching the provided design */}
      <header className="nav public-page-header" data-testid="public-page-header">
        <Link to="/" className="logo" data-testid="logo-link">RasheedGPT</Link>
        <ul className="public-desktop-navigation" data-testid="public-desktop-navigation">
          <li><Link to="/" data-testid="public-desktop-link-home">الرئيسية</Link></li>
          <li><Link to="/founder" className="cur" aria-current="page" data-testid="founder-nav-active">المؤسس</Link></li>
          <li><Link to="/how-it-works" data-testid="public-desktop-link-how-it-works">كيف يعمل</Link></li>
          <li><Link to="/subscribe" data-testid="public-desktop-link-subscribe">اشترك معنا</Link></li>
          <li><Link to="/feedback" data-testid="public-desktop-link-feedback">رأيك يهمنا</Link></li>
          <li><Link to="/login" className="lg" data-testid="public-desktop-link-login">تسجيل الدخول</Link></li>
        </ul>
        <Link to="/login" className="lmob" data-testid="mobile-login-btn">تسجيل الدخول</Link>
        <PublicMobileMenu />
      </header>

      <main data-testid="founder-page">
        {/* Left: info card */}
        <section>
          <span className="badge">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1l11 11-11 11L1 12z" /></svg>
            المؤسس
          </span>
          <h1>فريق <span>رشيد المميز</span></h1>
          <div className="card" style={{ '--c': active.c }}>
            <div className="bd" key={ord[0]} style={{ '--c': active.c }} data-testid="founder-card">
              <span className="role">{active.r}</span>
              <h2>{active.n}</h2>
              <p className="tt">{active.t}</p>
              <p className="bio">{active.b}</p>
              {active.g && (
                <div className="tags">{active.g.map((x, i) => <i key={i}>{x}</i>)}</div>
              )}
            </div>
          </div>
        </section>

        {/* Right: interactive stage */}
        <section>
          <div className="stage" data-testid="founder-stage">
            <i className="r r1"></i><i className="r r2"></i><i className="r r3"></i>
            <svg viewBox="0 0 100 100" aria-hidden="true">
              <circle className="tk" cx="50" cy="50" r="42" pathLength="100" />
              <circle className="rn" cx="50" cy="50" r="42" pathLength="100" />
            </svg>
            {P.map((p, k) => {
              const j = ord.indexOf(k);
              const centered = j === 0;
              const size = centered ? 54 : 21;
              const x = centered ? 50 : S[j - 1][0];
              const y = centered ? 50 : S[j - 1][1];
              return (
                <button
                  key={k}
                  className={`p${centered ? ' c' : ''}`}
                  style={{ '--c': p.c, '--d': `${k * 0.6}s`, left: `${x}%`, top: `${y}%`, width: `${size}%`, height: `${size}%`, zIndex: centered ? 3 : 4 }}
                  aria-label={p.n}
                  onClick={() => pick(k)}
                  data-testid={`founder-photo-${k}`}
                >
                  <span className="in"><img alt={p.n} src={p.img} /></span>
                  <b>{p.n}</b>
                </button>
              );
            })}
          </div>
          <p className="hint">اضغط على أي صورة للتعرف على صاحبها</p>
        </section>
      </main>
    </div>
  );
};

export default FounderPage;
